import {
  inject, observer,
} from 'mobx-react';
import React, {
  Component,
} from 'react';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  IAppConfigurationStore,
} from '../../mobx-store/storeInterfaces/appConfigurationInterface';

interface IProps {
  history: any;
  appConfigurationStore: IAppConfigurationStore;
}

@inject('appConfigurationStore')
@observer
class Settings extends Component<IProps> {
  tableHeader: any = [];

  tableData: any[] = [];

  tableCellTypes: TableCellTypes[] = [];

  title: string;

  constructor(props: IProps) {
    super(props);
    this.title = translate('settingsListPageTitle', {
    });
  }

  getSettingsTableHeader = () => [
    {
      title: translate('settingsListKeyColumnTitle', {
      }),
    },
    {
      title: translate('settingsListValueColumnTitle', {
      }),
    },
    {
      title: translate('settingsListEditColumnTitle', {
      }),
    },
  ];

  getSettingsTableData = () => this.props.appConfigurationStore.configurationsList
    .map((config) => ({
      ...config,
      edit: translate('settingsListEditColumnTitle', {
      }),
    }));

  getSettingsTableCellTypes = (): TableCellTypes[] => [
    {
      cellType: 'Text',
      key: 'key',
    },
    {
      cellType: 'Text',
      key: 'value',
    },
    {
      cellType: 'Button',
      key: 'edit',
      onClick: this.handleTableButtonCellClicked,
    },
  ];

  handleTableButtonCellClicked = (index: number, key: string) => {
    this.props.history.push(`/settings/${this.props.appConfigurationStore.configurationsList[index].key}/edit`);
  };

  render() {
    this.tableHeader = this.getSettingsTableHeader();
    this.tableData = this.getSettingsTableData();
    this.tableCellTypes = this.getSettingsTableCellTypes();
    return (
      <div>
        <GeneralTableComponent
          emptyMessage={translate('settingsListNoSettingsMessage', {
          })}
          title={this.title}
          tableHeader={this.tableHeader}
          tableData={this.tableData}
          tableCellTypes={this.tableCellTypes}
          loading={this.props.appConfigurationStore.loading}
        />
      </div>
    );
  }

  componentDidMount() {
    this.props.appConfigurationStore.getAppConfigurations();
  }
}

export default Settings;
